import React, { useEffect, useRef, useState } from "react";
import { IGetTotalViewIvRequest, IGetTotalViewIvResponse, IGetTradesResponse, IOrderModifyData, IPlaceOrderResponse, ITotalViewOption, LiveMarketData } from "./interfaces";


export const GetTotalIvForm = ({
  formId,
  optTotalViewReq,
  setOptTotalViewReq,
  getTotalViewIv,
  onAdd,
  onRemove,
}: {
  formId: string;
  optTotalViewReq: IGetTotalViewIvRequest;
  setOptTotalViewReq: React.Dispatch<
    React.SetStateAction<IGetTotalViewIvRequest>
  >;
  getTotalViewIv: (e: React.FormEvent) => void;
  onAdd: () => void;
  onRemove?: () => void;
}) => {
  const fieldId = (name: string) => `${name}-${formId}`;

  return (
    <form onSubmit={getTotalViewIv} data-ibkr-get-form className="flex gap-2">
      <div>
        <label htmlFor={fieldId("ticker")}>Ticker:</label>
        <input
          id={fieldId("ticker")}
          type="text"
          placeholder="AAPL"
          value={optTotalViewReq.ticker}
          onChange={(e) =>
            setOptTotalViewReq({ ...optTotalViewReq, ticker: e.target.value })
          }
        />
      </div>

      <div>
        <label htmlFor={fieldId("right")}>Right:</label>
        <input
          id={fieldId("right")}
          type="text"
          placeholder="C / P"
          value={optTotalViewReq.right}
          onChange={(e) =>
            setOptTotalViewReq({ ...optTotalViewReq, right: e.target.value })
          }
        />
      </div>

      <div>
        <label htmlFor={fieldId("start")}>Start:</label>
        <input
          id={fieldId("start")}
          type="text"
          placeholder="200"
          value={optTotalViewReq.start}
          onChange={(e) =>
            setOptTotalViewReq({ ...optTotalViewReq, start: e.target.value })
          }
        />
      </div>

      <div>
        <label htmlFor={fieldId("directional_limit")}>Dir Limit:</label>
        <input
          id={fieldId("directional_limit")}
          type="text"
          placeholder="20"
          value={optTotalViewReq.directional_limit}
          onChange={(e) =>
            setOptTotalViewReq({
              ...optTotalViewReq,
              directional_limit: e.target.value,
            })
          }
        />
      </div>

      <div>
        <label htmlFor={fieldId("skip_expiries")}>Skip:</label>
        <input
          id={fieldId("skip_expiries")}
          type="text"
          placeholder="0"
          value={optTotalViewReq.skip_expiries}
          onChange={(e) =>
            setOptTotalViewReq({
              ...optTotalViewReq,
              skip_expiries: e.target.value,
            })
          }
        />
      </div>

      <div>
        <label htmlFor={fieldId("number_of_expiries")}>Num Exp:</label>
        <input
          id={fieldId("number_of_expiries")}
          type="text"
          placeholder="2"
          value={optTotalViewReq.number_of_expiries}
          onChange={(e) =>
            setOptTotalViewReq({
              ...optTotalViewReq,
              number_of_expiries: e.target.value,
            })
          }
        />
      </div>

      <div className="flex gap-1">
        <button type="submit" className="btn btn-default mt-5">
          Get
        </button>
        <div className="flex flex-col mt-5 gap-0.5">
          <button
            type="button"
            className="btn btn-default flex-1 px-2 py-0 text-xs leading-none"
            title="Add another form below, copied from this one"
            onClick={onAdd}
          >
            +
          </button>
          {onRemove && (
            <button
              type="button"
              className="btn btn-default flex-1 px-2 py-0 text-xs leading-none"
              title="Remove this form"
              onClick={onRemove}
            >
              -
            </button>
          )}
        </div>
      </div>
    </form>
  );
};
